import { Cell } from '@/components/Bicester/Table/Cells/index';
import { getPrice } from '@/components/utils';
import _ from 'lodash';
import React from 'react';

export interface PriceCellProps {
  rowData?: BaseObject<any>;
  dataKey: string;
}

const PriceCell = ({ rowData, dataKey, ...props }: PriceCellProps) => {
  const value = _.get(rowData, dataKey);

  return <Cell {...props}>{getPrice(value)}</Cell>;
};

export default PriceCell;
